import { useEffect, useRef, useState } from "react";
import { API } from "@/lib/api";

// Voorstel 11 — live tijdlijn-events via Server-Sent Events (JWT in query), auto-reconnect; `verbonden` false → aanroeper valt terug op polling.
export function useLiveStream(onEvent, { klantId = null, actief = true } = {}) {
  const [verbonden, setVerbonden] = useState(false);
  const [laatste, setLaatste] = useState(null);
  const cb = useRef(onEvent);
  cb.current = onEvent;
  useEffect(() => {
    if (!actief) return undefined;
    const token = localStorage.getItem("token");
    if (!token || typeof EventSource === "undefined") return undefined;
    let es, timer, gestopt = false, wacht = 2000;
    const open = () => {
      const url = `${API}/live/stream?token=${encodeURIComponent(token)}${klantId ? `&klant_id=${encodeURIComponent(klantId)}` : ""}`;
      es = new EventSource(url);
      es.addEventListener("hallo", () => { setVerbonden(true); wacht = 2000; });
      es.addEventListener("tijdlijn", (e) => {
        try { const d = JSON.parse(e.data); setLaatste(new Date()); cb.current && cb.current(d); } catch { /* negeren */ }
      });
      es.onerror = () => {
        setVerbonden(false);
        es.close();
        if (!gestopt) { timer = setTimeout(open, wacht); wacht = Math.min(wacht * 2, 60000); }
      };
    };
    open();
    return () => { gestopt = true; clearTimeout(timer); es && es.close(); setVerbonden(false); };
  }, [klantId, actief]);
  return { verbonden, laatste };
}

export function LiveStatus({ verbonden, tid = "live-status" }) {
  return (
    <span className={`inline-flex items-center gap-1 text-[11px] ${verbonden ? "text-emerald-700" : "text-slate-400"}`} data-testid={tid} title={verbonden ? "Live verbonden: wijzigingen verschijnen binnen 5 s" : "Niet live verbonden: ververst elke minuut"}>
      <span className={`h-2 w-2 rounded-full ${verbonden ? "bg-emerald-500 animate-pulse" : "bg-slate-300"}`} />{verbonden ? "live" : "polling"}
    </span>
  );
}
